"use client";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { FC, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

type Props = {
	title: string;
	text: any;
};

const FaqItem: FC<Props> = ({ title, text }) => {
	const [isOpen, setIsOpen] = useState(false);
	const hasBlocksContent = Array.isArray(text);
	const markdownText = typeof text === "string" ? text : "";

	useEffect(() => {
		setIsOpen(false); // Ensures the component starts closed when the title changes
	}, [title]);

	return (
		<>
			<div
				onClick={() => setIsOpen(!isOpen)} // Toggles the isOpen state
				className='w-full py-[12px] flex items-center justify-between pl-[31px] max-desktop:pl-[17px] pr-[13px] max-tablet:py-[7px] max-desktop:py-[7px] max-desktop:pr-[7px] max-tablet:px-[19px] border-[2px] rounded-[15px] cursor-pointer no-transition'>
				<p className='text-[35px] tracking-[1.5px] max-desktop:tracking-[1px] max-desktop:text-[20px] text-white text-left leading-[46px] max-desktop:leading-[26px]'>
					{title}
				</p>
				<div
					className={`w-[47px] h-[47px] max-desktop:w-[26px] max-desktop:h-[26px] border-[2px] max-tablet:border-[1px] rounded-full flex items-center justify-center ${
						isOpen ? "rotate-0" : "rotate-180"
					} max-tablet:min-w-[25px] max-tablet:min-h-[25px] no-transition`}>
					<img
						src='/icons/triangle.svg'
						className='w-[25px] h-[25px] max-desktop:w-[14px] max-desktop:h-[14px] max-tablet:w-[12px] max-tablet:h-[12px]'
					/>
				</div>
			</div>
			<div
				className={`text-[35px] max-desktop:text-[20px] px-[31px] max-desktop:px-[20px] expand-text ${
					isOpen ? "pt-[36px] pb-[87px] open" : ""
				} no-transition`}>
				{hasBlocksContent ? (
					<BlocksRenderer content={text} />
				) : (
					markdownText && <ReactMarkdown>{markdownText}</ReactMarkdown>
				)}
			</div>
		</>
	);
};

export default FaqItem;
